import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "registration-qr-card" }
const _hoisted_2 = { class: "ds-panel ds-panel--space_lg" }
const _hoisted_3 = { class: "ds-panel__element ds-panel__element--offset_top" }
const _hoisted_4 = { class: "ds-caption ds-caption--size_lg ds-caption--weight_semi-bold ds-caption--appearance_center" }
const _hoisted_5 = { class: "ds-panel ds-panel--space_md" }
const _hoisted_6 = { class: "ds-panel__element ds-panel__element--offset_top" }
const _hoisted_7 = { class: "ds-caption ds-caption--size_sm ds-caption--appearance_center ds-caption--color_relief-2" }
const _hoisted_8 = { class: "ds-panel ds-panel--space_2xl" }
const _hoisted_9 = { class: "ds-panel__element ds-panel__element--offset_top" }
const _hoisted_10 = { class: "g-row g-row--justify_center" }
const _hoisted_11 = { class: "g-cell" }
const _hoisted_12 = ["src", "alt"]
const _hoisted_13 = { class: "ds-panel ds-panel--space_xl" }
const _hoisted_14 = { class: "ds-panel__element ds-panel__element--offset_top" }
const _hoisted_15 = { class: "g-row g-row--justify_center" }
const _hoisted_16 = { class: "g-cell" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_control_button = _resolveComponent("control-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", _hoisted_4, _toDisplayString($setup.$t("Ви зареєстровані на захід")), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("p", _hoisted_7, _toDisplayString($setup.$t("Це ваш персональний код для входу на захід. Покажіть його на вході — організатор відсканує.")), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("img", {
              class: "registration-qr-card__qr",
              src: $props.qrImageUrl,
              alt: $setup.$t('QR-код для чекіну')
            }, null, 8, _hoisted_12)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_control_button, {
              tag: "a",
              href: $props.qrImageUrl,
              download: "",
              rel: "noopener"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString($setup.$t("Завантажити")), 1)
              ]),
              _: 1
            }, 8, ["href"])
          ])
        ])
      ])
    ])
  ]))
}